import { InspectionStatus } from 'api';
import { Box, Link, Stack, Tooltip, Typography } from 'ui';

export const EvidenceInspectionSessionDetails = ({
  slug,
  deal,
  linkToExternalReport,
  currentStatus,
}: {
  slug: string;
  deal?: number;
  linkToExternalReport?: string | null;
  currentStatus: InspectionStatus;
}) => {
  const externalReportLink = linkToExternalReport || `https://drive.google.com/drive/search?q=${slug}`;
  const dealLink = deal ? `/post-deal/dealhub/deal/details/${deal}` : '';
  // link should be displayed only after inspection was completed
  const showLink = currentStatus === InspectionStatus.CO;

  return (
    <Stack>
      <Stack direction="row" spacing={1}>
        <Typography>Inspection slug:</Typography>
        {showLink ? (
          <Tooltip title={linkToExternalReport ? 'View external report' : 'Search for inspection in Google Drive'}>
            <Link data-testid="external-report-link" href={externalReportLink} target="_blank">
              {slug}
            </Link>
          </Tooltip>
        ) : (
          <Tooltip title="Once the inspection is completed, you will find here a link to the report.">
            <Box>{slug}</Box>
          </Tooltip>
        )}
      </Stack>
      {deal ? (
        <Stack direction="row" spacing={1}>
          <Typography>Deal ID:</Typography>
          <Tooltip title="View deal details">
            <Link data-testid="deal-link" href={dealLink} target="_blank">
              {deal}
            </Link>
          </Tooltip>
        </Stack>
      ) : null}
    </Stack>
  );
};
